import { whyChooseUs, testimonials } from "../data/mock";
import { Trophy, Award, Headphones, Zap, Quote } from "lucide-react";
import { motion } from "framer-motion";
import { useState } from "react";

const iconMap = { Trophy, Award, Headphones, Zap };

export const WhyChooseSection = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  return (
    <section
      className="relative w-full"
      style={{ background: "#0B0E1E", padding: "120px 7.6923%" }}
    >
      <div className="max-w-[1400px] mx-auto">
        {/* Why Choose Us */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-20"
        >
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-[2px] rounded-full" style={{ background: "#7B68EE" }} />
            <span
              className="text-sm tracking-widest uppercase"
              style={{ color: "#7B68EE", fontFamily: "'Kode Mono', monospace" }}
            >
              Why Us
            </span>
          </div>
          <h2
            style={{
              fontFamily: "'Kode Mono', monospace",
              fontWeight: 600,
              fontSize: "clamp(32px, 4vw, 48px)",
              color: "#F0F0FF",
              letterSpacing: "-0.02em",
              lineHeight: 1.1,
            }}
          >
            Why Manchi Group
          </h2>
        </motion.div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-32">
          {whyChooseUs.map((item, index) => {
            const IconComponent = iconMap[item.icon];
            return (
              <motion.div
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.12 }}
                className="group rounded-xl"
                style={{
                  padding: "36px 28px",
                  background: "#121530",
                  border: "1px solid rgba(123,104,238,0.08)",
                  transition: "all 0.4s ease-in-out",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = "rgba(123,104,238,0.25)";
                  e.currentTarget.style.background = "#171B36";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = "rgba(123,104,238,0.08)";
                  e.currentTarget.style.background = "#121530";
                }}
              >
                <div
                  className="w-12 h-12 flex items-center justify-center mb-6 rounded-lg"
                  style={{ background: "rgba(123,104,238,0.1)", border: "1px solid rgba(123,104,238,0.2)" }}
                >
                  {IconComponent && (
                    <IconComponent size={20} style={{ color: "#A78BFA" }} />
                  )}
                </div>
                <h3
                  className="mb-3"
                  style={{
                    fontFamily: "'Kode Mono', monospace",
                    fontSize: "18px",
                    fontWeight: 600,
                    color: "#F0F0FF",
                  }}
                >
                  {item.title}
                </h3>
                <p
                  style={{
                    fontFamily: "'Kode Mono', monospace",
                    fontSize: "14px",
                    color: "#8585A8",
                    lineHeight: 1.7,
                  }}
                >
                  {item.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        {/* Testimonials */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center gap-3 mb-10">
            <div className="w-8 h-[2px] rounded-full" style={{ background: "#7B68EE" }} />
            <span
              className="text-sm tracking-widest uppercase"
              style={{ color: "#7B68EE", fontFamily: "'Kode Mono', monospace" }}
            >
              Client Voices
            </span>
          </div>

          <div
            className="relative rounded-2xl"
            style={{
              background: "#121530",
              padding: "56px",
              border: "1px solid rgba(123,104,238,0.12)",
            }}
          >
            <Quote
              size={40}
              style={{
                color: "rgba(123,104,238,0.2)",
                marginBottom: "24px",
              }}
            />

            <p
              className="mb-8"
              style={{
                fontFamily: "'Kode Mono', monospace",
                fontSize: "clamp(18px, 2.5vw, 24px)",
                color: "#C4C4E0",
                lineHeight: 1.6,
                maxWidth: "800px",
              }}
            >
              \"{testimonials[activeTestimonial].quote}\"
            </p>

            <div className="flex items-center justify-between flex-wrap gap-4">
              <div>
                <div
                  style={{
                    fontFamily: "'Kode Mono', monospace",
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#F0F0FF",
                    marginBottom: "4px",
                  }}
                >
                  {testimonials[activeTestimonial].name}
                </div>
                <div
                  style={{
                    fontFamily: "'Kode Mono', monospace",
                    fontSize: "13px",
                    color: "#8585A8",
                  }}
                >
                  {testimonials[activeTestimonial].role}
                </div>
              </div>

              <div className="flex gap-2">
                {testimonials.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveTestimonial(i)}
                    className="border-none cursor-pointer transition-all duration-300 rounded-full"
                    style={{
                      width: i === activeTestimonial ? "40px" : "12px",
                      height: "4px",
                      background:
                        i === activeTestimonial ? "#7B68EE" : "rgba(123,104,238,0.2)",
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
